import { ClinicalDataProps, FilterOptionProps } from '#pages/ClinicalDataList';

interface useFilterProps {
  dummyData: ClinicalDataProps[];
  filterOption: FilterOptionProps;
}

export const useFilter = ({ dummyData, filterOption }: useFilterProps) => {
  const { round, lectureName, sex, age } = filterOption;

  const filteredData = dummyData.filter(item => {
    // 1. Round 필터
    const roundCondition = round === 0 || filterByRound(item.rounds, round);

    // 2. Lecture Name 필터 (숫자 코드 매칭)
    const lectureCondition =
      lectureName === 0 ||
      item.lectureName === getLectureNameByCode(lectureName);

    // 3. 성별 필터
    const sexCondition = sex === 0 || item.sex === getSexByCode(sex);

    // 4. 나이대 필터
    const ageCondition = age === 0 || getAgeGroup(item.age) === age;

    // 모든 조건을 만족하는지 확인
    return roundCondition && lectureCondition && sexCondition && ageCondition;
  });
  return filteredData;
};

// Helper function: round 필터링
const filterByRound = (rounds: number, roundFilter: number): boolean => {
  switch (roundFilter) {
    case 1:
      return rounds >= 10; // 10회 이상
    case 2:
      return rounds >= 20; // 20회 이상
    case 3:
      return rounds >= 30; // 30회 이상
    default:
      return true; // 전체 (0일 때)
  }
};

// Helper function: lectureName 코드에 따른 이름 반환
const getLectureNameByCode = (code: number): string => {
  switch (code) {
    case 1:
      return '다이어트';
    case 2:
      return '체형교정';
    case 3:
      return '재활운동';
    case 4:
      return '바디프로필';
    default:
      return '';
  }
};

// Helper function: 성별 코드에 따른 반환
const getSexByCode = (code: number): string => {
  switch (code) {
    case 1:
      return '남성';
    case 2:
      return '여성';
    default:
      return '';
  }
};

// Helper function: 나이를 나이대 코드로 변환
const getAgeGroup = (age: number): number => {
  if (age < 20) return 1; // 20대 이하
  if (age >= 20 && age < 30) return 2; // 30대
  if (age >= 30 && age < 40) return 3; // 40대
  if (age >= 40 && age < 50) return 4; // 50대 이상
  return 0; // 전체
};
